import Phaser from 'phaser';

export class PhaserGame extends Phaser.Game {
  // eslint-disable-next-line no-useless-constructor
  constructor(config: Phaser.Types.Core.GameConfig) {
    super(config);
  }

  updateParent(newParentId: string) {
    const { canvas } = this;

    if (canvas) {
      const newParent = document.getElementById(newParentId);
      if (newParent) {
        newParent.appendChild(canvas);
      }
    }
  }
}
